import { Payment } from "~/features/payment/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const PaymentPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxltlSingleInvoice");

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled ? <Payment /> : <Construction />;
};
